import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Theme from '@adsk/alloy-react-theme';
import Button from '@adsk/alloy-react-button';
import { T } from '../helpers/i18n';

class IssuePreviewNoWorkflowConfiguration extends PureComponent {
  render() {
    const { closePopup } = this.props;
    return (
      <div>
        <div
          css={[
            {
              padding: `30px 35px`,
            },
          ]}
        >
          <div
            css={[
              Theme.typography.bodyLargeBold,
              {
                marginBottom: '10px',
              },
            ]}
          >
            <p>{T.translate('transition.workflowConfigurationError.title')}</p>
          </div>
          <div css={[Theme.typography.bodyMedium]}>
            <p>{T.translate('transition.workflowConfigurationError.message')}</p>
          </div>
        </div>

        <div
          css={[
            {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              padding: '0 15px',
              height: '67px',
              borderTop: `1px solid ${Theme.colors.charcoal700}`,
            },
          ]}
        >
          <Button
            variant={Button.VARIANTS.PRIMARY}
            onClick={closePopup}
            css={[
              {
                minWidth: '85px',
              },
            ]}
          >
            {T.translate('navigation.close')}
          </Button>
        </div>
      </div>
    );
  }
}

IssuePreviewNoWorkflowConfiguration.displayName = 'IssuePreviewNoWorkflowConfiguration';

IssuePreviewNoWorkflowConfiguration.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default IssuePreviewNoWorkflowConfiguration;
